import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const token = authService.getToken();
  // withCredentials on every request (not just when a JWT exists): this is what makes the
  // browser attach the Cloudflare Access CF_Authorization cookie to cross-origin calls to the
  // API once Access has set it — without it, the cookie sits in the jar but is never sent.
  req = req.clone({
    withCredentials: true,
    setHeaders: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return next(req);
};
